import React from 'react';
import './styles.scss';

const PageTitle = props => <div className='pageTitle'>{props.title}</div>;

export default PageTitle;
